import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiBook } from 'react-icons/fi';
import './theme.css';

const NavLink = ({ to, children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = location.pathname === to || 
                   (to === '/tools/flashcards' && location.pathname === '/tools/flashcards') ||
                   (to === '/tools/flashcards/study' && location.pathname.startsWith('/tools/flashcards/study'));
  return (
    <button
      className={`nav-link ${isActive ? 'active' : ''}`}
      onClick={() => navigate(to)}
    >
      {children}
    </button>
  );
};

const FlashcardsNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  return (
    <nav className="flashcards-nav">
      <div className="nav-brand">
        <div className="nav-logo">
          <FiBook />
        </div>
        <div className="nav-title">
          <h1>Flashcards</h1>
          <p>Learn • Memorize • Excel</p>
        </div>
      </div>
      <div className="nav-links">
        <NavLink to="/tools/flashcards">Home</NavLink>
        <NavLink to="/tools/flashcards/study">Study</NavLink>
        <NavLink to="/tools/flashcards/library">Library</NavLink>
        <button className="nav-cta" onClick={() => navigate('/tools/flashcards/create')}>
          Create Flashcards
        </button>
      </div>
    </nav>
  );
};

export default FlashcardsNav; 